import api from "../../../../../services/api";

import React, { useState, useEffect } from "react";
import { useParams } from "react-router-dom";

import * as globalComponents from "../../../../../components";
import utils from "../../../../../shared/utils.js";

import "../../styles.css";

export default function CrefitoNormatives({ sectionName }) {
  const { accessType } = useParams();
  const [data, setData] = useState({
    sectionName: "",
    subsections: [],
  });

  const dir = [
    {
      title: "Legislação",
      url: `/${accessType}/legislacao`,
    },
  ];

  const parseData = (data) => {
    const [day, month, year] = [
      String(data).substring(6, 8),
      String(data).substring(4, 6),
      String(data).substring(0, 4),
    ];
    return `${day}/${month}/${year}`;
  };

  useEffect(() => {
    window.scroll(0, 0);
    async function fetchData() {
      await api
        .get("/normativas")
        .then((res) => {
          const section = res.data.find(
            (item) => item.sectionName === sectionName
          );

          if (!section) {
            setData({ sectionName: "", subsections: [] });
            return;
          }

          section.subsections.sort((a, b) => b.Data - a.Data);

          setData(section);
        })
        .catch((err) => {
          console.log(err);
        });
    }
    fetchData();
  }, [sectionName]);

  return (
    <>
      <globalComponents.Header />

      <globalComponents.Breadcrumbs
        title={`Normativas Crefito2 / ${data.sectionName}`}
        dir={dir}
      />

      <div className="container">
        <div className="title__publications">
          <strong>{data.sectionName}</strong>
          <div className="responsive-table-container">
            <table className="legislation-table">
              <thead>
                <tr>
                  <th>Título</th>
                  <th>Descrição</th>
                  <th>Data de Publicação</th>
                  <th>Anexo</th>
                </tr>
              </thead>
              <tbody>
                {data.subsections.map((contentValue, contentIndex) => {
                  const link = `/${accessType}/legislacao/normativas_crefito2/${sectionName
                    .toLowerCase()
                    .normalize("NFD")
                    .replace(/[\u0300-\u036f]/g, "")
                    .replace(/[^a-zA-Z0-9\s]/g, "")
                    .replace(/ /g, "_")}/${utils.slugifyTitle(
                    contentValue.Titulo
                  )}_${contentValue.Codigo}`;
                  const subtitle = contentValue.Subtitulo
                    ? contentValue.Subtitulo.replaceAll("<br />", "")
                    : sectionName === "Portarias"
                    ? "Dispõe sobre nomeação de servidor efetivo, e dá outras providências."
                    : "";

                  return (
                    <tr key={contentIndex}>
                      <td>
                        <a href={link} className="title-link">
                          {contentValue.Titulo?.replaceAll("<br />", "")}
                        </a>
                      </td>
                      <td>{subtitle}</td>
                      <td>{parseData(contentValue.Data) || "-"}</td>
                      <td>
                        <a
                          href={contentValue.Link}
                          className={contentValue.Link ? "title-link" : ""}
                          target="_blank"
                          rel="noreferrer"
                        >
                          {contentValue.Link?.split("/").pop() || "N/A"}
                        </a>
                      </td>
                    </tr>
                  );
                })}
              </tbody>
            </table>
          </div>
        </div>
      </div>

      <globalComponents.Footer />
    </>
  );
}
